import api from '../../services/api';

const usePipelines = () => {
  const findAll = async () => {
    const { data } = await api.get('/pipelines');
    return data;
  };

  const findById = async (id, options = {}) => {
    if (!id) {
      throw new Error('ID da pipeline é obrigatório');
    }
    const { params } = options;
    const config = params && Object.keys(params).length > 0 ? { params } : {};
    const { data } = await api.get(`/pipelines/${id}`, config);
    return data;
  };

  const update = async (id, updateData) => {
    const { data } = await api.patch(`/pipelines/${id}`, updateData);
    return data;
  };

  return { findAll, findById, update };
};

export default usePipelines;
